import BigNumber from 'bignumber.js';

export interface DefaultEstimatedGas {
    tokensToTokens: BigNumber[];
    tokensToEth: BigNumber[];
    ethToTokens: BigNumber[];
}
